module.exports = __webpack_public_path__ + "static/media/jim.c387e9e9.jpg";